import { styled } from '@common/ui-components';

export const StyledLabel = styled('label')`
  display: none;
`;
